import React from "react"
import * as styles from "./applyContent.module.scss"
import { useAppContext } from "@src/context/appContext"

const ApplyContent = React.memo(() => {
  const { langData } = useAppContext()
  return (
    <div className={styles.container}>
      <h1>Contact</h1>
      <hr />

      <div className={styles.emailTip}>
        {langData.apply_contact}
        <br />
        <a href="mailto:publishing@gcores.com">publishing@gcores.com</a>
      </div>
      <div className={styles.tip}>
        <p>{langData.apply_notice}</p>
        <p>{langData.apply_requirements}</p>
      </div>
    </div>
  )
})

ApplyContent.displayName = "ApplyContent"
export default ApplyContent
